module.exports = "// perloader Form js\r\n$(window).on('load', function () {\r\n  $('.preload-main').delay(1000).fadeOut(800)\r\n})\r\n"